import { createResourceMixin } from '../utils/store'

export default createResourceMixin('galleries', 'gallery')
